import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer, Space, Badge } from "antd";
import { PlusCircleOutlined, RotateLeftOutlined } from "@ant-design/icons";
import { useParams, Link } from "react-router-dom";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import SideExpendituresTable from "./table";
import SideExpendituresTableDetails from "./tableDetails";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";
import AddNewSideExpenditure from "./addNewRecord";
const GETSIDEEXPENDITURES = gql`
  query (
    $paginateInput: PaginateInput!
    $searchInput: ExpenditureSearchInput!
  ) {
    getExpendituresCount(searchInput: $searchInput)
    getExpenditures(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      updatedAt
      documentImg
      amount
      description
      occurrenceAt
    }
  }
`;

function SideExpenditures(props) {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchPhrase, setFilterSearchPhrase] = useState("");
  const [detailsDerawer, setDetailsDrawer] = useState(false);
  const [addRecordsDerawer, setAddRecordsDrawer] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [getSideExpenditures, sideExpenditures] = useLazyQuery(
    GETSIDEEXPENDITURES,
    {
      fetchPolicy: "no-cache",
      onCompleted(data) {
        setTableData(data);
      },
    }
  );

  const { result } = useParams();
  useEffect(() => {
    getSideExpenditures({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchPhrase,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchPhrase]);

  const dataUpdated = () => {
    getSideExpenditures({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          description: filterSearchPhrase,
        },
      },
    });
  };

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchPhrase(phrase);
  };

  const openDetailsDrawer = (id, name) => {
    setDetailsDrawer({ id, name });
  };
  const closeDetailsDrawer = () => {
    setDetailsDrawer(false);
  };

  if (sideExpenditures.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <Badge.Ribbon
      style={{
        left: "-32px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
      text={
        <div onClick={() => setAddRecordsDrawer(true)}>
          <span style={{ padding: "10px", color: "white" }}>
            <PlusCircleOutlined /> ثبت هزینه جدید
          </span>
        </div>
      }
    >
      <>
        <Drawer
          title="ثبت هزینه جدید"
          placement="left"
          open={addRecordsDerawer}
          onClose={() => setAddRecordsDrawer(false)}
          size={windowSize >= 750 ? "large" : null}
          width={windowSize < 750 ? windowSize - 50 : null}
        >
          <AddNewSideExpenditure onDataUpdate={dataUpdated} />
        </Drawer>
        <Drawer
          title="جزییات هزینه"
          placement="right"
          open={detailsDerawer}
          onClose={closeDetailsDrawer}
          size={windowSize >= 750 ? "large" : null}
          width={windowSize < 750 ? windowSize - 50 : null}
        >
          <SideExpendituresTableDetails
            id={detailsDerawer.id}
            onCloseDrawer={closeDetailsDrawer}
            onDataUpdate={dataUpdated}
          />
        </Drawer>

        <TableFilters
          onFilterDate={filterDate}
          onFilterSearch={filterSearch}
          hint={"بر اساس تاریخ ثبت"}
        />
        <Space></Space>
        <br />
        <SideExpendituresTable
          data={tableData}
          onDataUpdate={dataUpdated}
          onSort={sort}
          onPageChange={pageChange}
          currentPage={currentPage}
          loading={sideExpenditures.loading}
          onOpenDrawer={openDetailsDrawer}
        />
      </>
    </Badge.Ribbon>
  );
}

export default SideExpenditures;
